import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FangPopoverModule} from './popover/fang-popover.module';
import {ClickOutsideElementModule} from './click-outside/click-outside-element.module';


@NgModule({
	imports: [
		CommonModule,
		FangPopoverModule,
		ClickOutsideElementModule
	],
	exports: [
		FangPopoverModule,
		ClickOutsideElementModule
	],
	declarations: [],
	providers: [],
	entryComponents: []
})
export class FangDirectivesModule {
}
